var plugin_rtlignore_default = {
  "alignLeft": "d0tji",
  "textWrapNowrap": "g7mpm",
  "alignRight": "_1YBFu",
  "alignCenter": "H26uE",
  "sizeFullWidth": "_--XlA",
  "renderedInTable": "_4xEzv",
  "sizeOriginal": "C0Ubb",
  "sizeContent": "_6QMvI",
  "sizeSmall": "cer0R",
  "sizeSmallCenter": "Z08z-",
  "flex": "KHDGD",
  "atomic": "jbVs4",
  "embed": "RnXN1",
  "horizontalScrollbar": "TNs5q",
  "pluginContainerMobile": "cyYRM"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
